/**
 * Parses data-prop-allowed-slugs (JSON array string).
 * @param {string|unknown} value - Attribute value (usually a string)
 * @returns {string[]|null} Array of slugs or null if invalid/absent (no filter applied)
 */
export function parseAllowedSlugs(value) {
  if (value == null || value === '') return null;
  try {
    const parsed = JSON.parse(typeof value === 'string' ? value : String(value));
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/**
 * Filters places to only those whose slug is in the allowed list (client-side filter, e.g. transfer flow).
 * @param {Array<{ slug?: string }>} places - Place objects from the places API
 * @param {string[]|null|undefined} allowedSlugs - Allowed slug values, or empty to skip filtering
 * @returns {Array} Filtered places or original array if no filter applies
 */
export function filterByAllowedSlugs(places, allowedSlugs) {
  if (!allowedSlugs || !Array.isArray(allowedSlugs) || allowedSlugs.length === 0) return places;
  const set = new Set(allowedSlugs);
  return (places || []).filter(p => p && set.has(p.slug));
}
